// Libraries
var React = require('react');

// Components
var FeaturedSponsors = require('./FeaturedSponsors');
var SecondarySponsors = require('./SecondarySponsors');

class SponsorsModule extends React.Component {
	render() {
		return (
			<div className="Sponsors">
				<div className="Sponsors__wrapper">
					<FeaturedSponsors data={this.props.data.featuredSponsors} />
					<SecondarySponsors data={this.props.data.secondarySponsors} />
				</div>	
			</div>	
		)
	}
}

module.exports = SponsorsModule;


// WEBPACK FOOTER //
// ./src/components/Sponsors/SponsorsModule.js